<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <div v-if="category">
      <b-card>

        <b-form>
          <b-row>

            <b-col
                class="mb-1"
                cols="12"
            >
              <h3>ویرایش دسته بندی</h3>
            </b-col>

            <!-- Field: name -->
            <b-col
                cols="12"
                md="4"
            >
              <b-form-group
                  label-for="name"
              >
                <b-form-input
                    id="name"
                    v-model="category.name"
                />
              </b-form-group>
            </b-col>

            <b-col class="my-1" cols="12">
              <span>توضیحات :</span>
              <ckEditorMain ref="editorContent" :defaultContent="category.description"
                            @getEditorContent="setEditorContent"></ckEditorMain>
            </b-col>
          </b-row>
        </b-form>

        <!-- Action Buttons -->
        <b-button
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            class="mt-1 mb-sm-0 mr-0 mr-sm-1"
            variant="primary"
            @click="updateCategory"
        >
          ذخیره تغییرات
        </b-button>

      </b-card>

<!--      <b-card>-->

<!--        <b-row>-->
<!--          <b-col-->
<!--              class="mb-1"-->
<!--              cols="12"-->
<!--          >-->
<!--            <h3>خصوصیات دسته بندی</h3>-->
<!--          </b-col>-->

<!--          <b-table-->
<!--              ref="refUserListTable"-->
<!--              :fields="myTableColumns"-->
<!--              :items="categoryProperties"-->
<!--              bordered-->
<!--              class="position-relative"-->
<!--              empty-text="خصوصیتی یافت نشد."-->
<!--              primary-key="id"-->
<!--              responsive-->
<!--              show-empty-->
<!--              striped-->
<!--          >-->

<!--            &lt;!&ndash; Column: delete &ndash;&gt;-->

<!--            <template #cell(delete)="data">-->

<!--              <div v-b-modal.modal-delete-->
<!--                   class="cursor-pointer d-flex flex-row w-25"-->
<!--                   @click="showModal(data.item.categoryPropertyId)"-->
<!--              >-->
<!--                <feather-icon class="text-danger" icon="TrashIcon" size="20"/>-->
<!--              </div>-->

<!--            </template>-->

<!--            <template #cell(edit)="data">-->

<!--              <b-button v-b-modal.modal-center class="cursor-pointer d-flex flex-row"-->
<!--                        @click="setUpdateCategoryPropertyData(data.item)">-->
<!--                <feather-icon icon="EditIcon" size="20"/>-->
<!--              </b-button>-->

<!--            </template>-->

<!--          </b-table>-->

<!--          <b-col-->
<!--              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"-->
<!--              cols="12"-->
<!--          >-->
<!--            <b-button-->
<!--                variant="primary"-->
<!--                @click="addNewCategoryProperty = !addNewCategoryProperty"-->
<!--            >-->
<!--              <span class="text-nowrap">+ ساخت خصوصیت جدید</span>-->
<!--            </b-button>-->
<!--          </b-col>-->
<!--          &lt;!&ndash;   new Category name  &ndash;&gt;-->
<!--          <transition name="fade">-->
<!--            <b-col-->
<!--                v-if="addNewCategoryProperty"-->
<!--                class="d-flex align-items-center justify-content-start mb-1 mb-md-0 mt-1"-->
<!--                cols="12"-->
<!--            >-->
<!--              <b-col md="8">-->
<!--                <div class="form-label-group">-->
<!--                  <b-form-input-->
<!--                      id="propertyName"-->
<!--                      v-model="defaultCreateCategoryPropertyData.name"-->
<!--                      placeholder="نام خصوصیت"-->
<!--                  />-->
<!--                </div>-->
<!--              </b-col>-->
<!--              <b-col class="mb-1" md="2">-->
<!--                <b-button-->
<!--                    variant="success"-->
<!--                    @click="createProductCategoryProperty"-->
<!--                >-->
<!--                  <span class="text-nowrap">ساخت</span>-->
<!--                </b-button>-->
<!--              </b-col>-->
<!--            </b-col>-->
<!--          </transition>-->

<!--        </b-row>-->

<!--      </b-card>-->

      <!-- modal vertical center -->
      <b-modal
          v-if="updateCategoryPropertyData !== null"
          id="modal-center"
          centered
          ok-only
          ok-title="ثبت"
          title="ویرایش خصوصیت"
          @ok="updateCategoryProperty"

      >
        <b-form-group
            invalid-feedback="Name is required"
            label="Name"
            label-for="name-input"
        >
          <b-form-input
              id="name-input"
              v-model="updateCategoryPropertyData.name"
              required
          />
        </b-form-group>
      </b-modal>
      <!-- modal vertical center -->
    </div>
  </b-overlay>
</template>

<script>
import {
  ProductCategoryGetRequest,
  ProductCategoryPropertyCreateRequest,
  ProductCategoryPropertyDeleteRequest,
  ProductCategoryPropertyGetByCategoryIdRequest,
  ProductCategoryPropertyUpdateRequest,
  ProductCategoryUpdateRequest
} from "@/libs/Api/Product";
import {
  BButton,
  BCard,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BModal,
  BOverlay,
  BRow,
  BTable,
} from 'bootstrap-vue'
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import ckEditorMain from "@/views/components/ckEditorMain";

export default {
  title: "ویرایش دسته بندی - پنل ادمین لنزآوا",
  name: "categories-edit",
  data() {
    return {
      category: null,
      showOverlay: false,
      categoryProperties: null,
      deleteItem: null,
      categoryId: this.$route.params.id,
      addNewCategoryProperty: false,
      myTableColumns: [
        {key: 'categoryPropertyId', label: 'شناسه'},
        {key: 'name', label: 'نام'},
        {key: 'delete', label: 'حذف'},
        {key: 'edit', label: 'ویرایش'},
      ],
      defaultCreateCategoryPropertyData: {
        isDeleted: false,
        categoryPropertyId: 0,
        categoryId: this.$route.params.id,
        name: ""
      },
      updateCategoryPropertyData: null,
    }
  },
  async created() {
    await this.getCategory();
    await this.getCategoryProperty();
  },
  methods: {
    async getCategory() {
      let _this = this;
      _this.showOverlay = true;

      let productCategoryGetRequest = new ProductCategoryGetRequest(_this);
      productCategoryGetRequest.setId(_this.categoryId);
      await productCategoryGetRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.category = content
      }, function (error) {
        _this.showOverlay = false;
      })
    },
    async getCategoryProperty() {
      let _this = this;
      _this.showOverlay = true;

      let productCategoryPropertyGetByCategoryIdRequest = new ProductCategoryPropertyGetByCategoryIdRequest(_this);
      productCategoryPropertyGetByCategoryIdRequest.setId(_this.categoryId);
      await productCategoryPropertyGetByCategoryIdRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.categoryProperties = content
      }, function (error) {
        _this.showOverlay = false;
      })
    },
    async updateCategory() {
      let _this = this;
      _this.showOverlay = true;

      let productCategoryUpdateRequest = new ProductCategoryUpdateRequest(_this);
      productCategoryUpdateRequest.setParams(_this.category);
      await productCategoryUpdateRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `تغییرات اعمال شد.`,
          },
        })
        _this.getCategory()
      }, function (error) {
        _this.showOverlay = false;
      })
    },
    async createProductCategoryProperty() {
      let _this = this;

      let productCategoryPropertyCreateRequest = new ProductCategoryPropertyCreateRequest(_this);
      productCategoryPropertyCreateRequest.setParams(_this.defaultCreateCategoryPropertyData);
      await productCategoryPropertyCreateRequest.fetch(function (content) {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `دسته بندی جدید اضافه شد.`,
          },
        })
        _this.getCategoryProperty();
      }, function (error) {
        console.log(error)
      })
    },
    async deleteCategoryProperty(param) {
      let _this = this;

      let productCategoryPropertyDeleteRequest = new ProductCategoryPropertyDeleteRequest(_this);
      productCategoryPropertyDeleteRequest.setId(param);
      await productCategoryPropertyDeleteRequest.fetch(function (content) {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `دسته بندی جدید حذف شد.`,
          },
        })
        _this.getCategoryProperty();
      }, function (error) {
        console.log(error)
      })
    },
    async updateCategoryProperty() {
      let _this = this;
      _this.showOverlay = true;

      let productCategoryPropertyUpdateRequest = new ProductCategoryPropertyUpdateRequest(_this);
      productCategoryPropertyUpdateRequest.setParams(_this.updateCategoryPropertyData);
      await productCategoryPropertyUpdateRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `دسته بندی جدید اضافه شد.`,
          },
        })
        _this.getCategoryProperty();
      }, function (error) {
        _this.showOverlay = false;
      })
    },
    setUpdateCategoryPropertyData(param) {
      this.updateCategoryPropertyData = param;
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param
    },
    setEditorContent(content) {
      this.category.description = content
    },
  },
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BFormGroup,
    BForm,
    BModal,
    ckEditorMain,
    vSelect,
  }
}
</script>

<style scoped>

</style>
